import {
  type BusinessServiceConfig,
  Strategy,
  AbstractBusinessService,
} from '../core';
import { type LocationDetails } from './users.types';
import { usersOGService } from './rtkquery/users.og';

const strategyMap = {
  fetchLocationDetails: Strategy.OG,
};

export type UsersServiceInitConfig<StoreType> = Omit<
  BusinessServiceConfig<StoreType>,
  'serviceName' | 'strategyMap'
>;

export class UsersService<StoreType> extends AbstractBusinessService<
  keyof typeof strategyMap,
  StoreType
> {
  constructor({ store, logger }: UsersServiceInitConfig<StoreType>) {
    super({ serviceName: 'UsersService', store, logger, strategyMap });
  }

  async fetchLocationDetails(): Promise<LocationDetails> {
    if (this.getStrategy('fetchLocationDetails') === Strategy.OG) {
      const response = await this.dispatchAction<LocationDetails>(
        usersOGService.endpoints.getLocationDetails.initiate(null),
      );
      if ('data' in response) {
        return response.data;
      } else {
        throw response.error;
      }
    }
    throw new Error('Unsupported strategy');
  }
}
